<div class="workflow-container">
    <div class="about-container">
  <!-- Header Section -->
  <div class="header">
    <h1>Well Trajectory Validation Tool (WTV)</h1>
  </div>

  <!-- Introduction -->
  <div class="intro-section">
    <p>
      The WTV tool stands for <strong>Well Trajectory Validation Tool</strong>, a specialized internal application developed to automate and enhance the quality 
      control (QC) of directional survey data and bottom hole locations used in exploration workflows. The Well Trajectory Validation Tool is built on a modern, scalable 
      architecture leveraging cloud services and advanced mathematical algorithms. The system processes multiple directional survey sources, validates wellbore trajectories, 
      and provides real-time feedback to users through a responsive web interface. Below are the architectural diagrams that illustrate the system's design, 
      component interactions, and data flow.
    </p>
  </div>

  <!-- Purpose and Capabilities Section -->
  <div class="section-title">
    <h2>Purpose and Capabilities</h2>
  </div>

  <div class="capabilities-grid">
    <div class="card card-blue">
      <h3>Trajectory QC Automation</h3>
      <p>
        Validates directional survey data including measured depth, inclination, and azimuth. 
        Calculates 3D wellbore paths using minimum curvature method and compares calculated 
        bottom hole positions against reported locations.
      </p>
    </div>

    <div class="card card-blue">
      <h3>Multi-Source Integration</h3>
      <p>
        Supports ingestion from external sources like IHS Energy, state databases, and internal 
        repositories, with coordinate transformation capabilities for multiple spatial reference systems.
      </p>
    </div>

    <div class="card card-orange">
      <h3>Error Detection & Reporting</h3>
      <p>
        Includes automated flagging of surveys with position discrepancies exceeding tolerance thresholds, 
        detailed logs, and notifications to help users identify and resolve data quality issues.
      </p>
    </div>

    <div class="card card-teal">
      <h3>Statistical Analysis</h3>
      <p>
        Provides comprehensive statistical outputs including distance variance distributions, 
        accuracy metrics, and visualization of survey quality across entire datasets.
      </p>
    </div>
  </div>

  <!-- Strategic Impact Section -->
  <div class="section-title">
    <h2>Strategic Impact</h2>
  </div>

  <div class="impact-grid">
    <div class="impact-card impact-green">
      <h3>Cost Avoidance</h3>
      <p>
        Prevents errors that could lead to multi-million dollar losses (e.g., 
        incorrect drilling targets, lease boundary violations, well collisions).
      </p>
    </div>

    <div class="impact-card impact-blue">
      <h3>Operational Safety</h3>
      <p>
        Ensures trajectory accuracy, reducing risks to drilling operations, preventing 
        wellbore collisions, and maintaining regulatory compliance.
      </p>
    </div>
  </div>

  <!-- Workflow Section -->
  <div class="section-title">
    <h2>WTV Workflow</h2>
  </div>

  <div class="workflow-section">
    <div class="workflow-image">
      <!-- <img src="assets/wtv-workflow.png" alt="High Level Architecture of Well Trajectory Validation Tool" /> -->
      <p class="image-caption">Coming Soon</p>
    </div>
  </div>
</div>

</div>